export const sumArrayItems = (array: number[]) => {
  return array.reduce((acc: number, el: number) => acc + el, 0);
};
